// Path helpers for Giraffe — works in both the main app (/giraffe/...) and
// the standalone subdomain (giraffe.wernerdutoit.co.za, paths start at /).
const base = () =>
  window.location.hostname.startsWith('giraffe.') ? '' : '/giraffe';

export const giraffeRoot      = ()     => base() || '/';
export const giraffeCountries = ()     => `${base()}/countries`;
export const giraffeTrip      = (id)   => `${base()}/${id}`;
export const giraffeSettings  = (id)   => `${base()}/${id}/settings`;
export const giraffePublish   = (id)   => `${base()}/${id}/publish`;
export const giraffeMemoir    = (slug) => `${base()}/memoir/${slug}`;

// Absolute, no-auth, view-only itinerary link (costs hidden). Same path on the
// main app and the giraffe subdomain, so origin-relative is host-agnostic.
export const giraffeShareUrl  = (slug) => `${window.location.origin}/trip/${slug}`;

// Canonical, no-auth, view-only link to a single public postcard. Always the
// www apex under /gallery (not the copy origin) so shares are consistent and
// dodge messenger spam heuristics; human-readable slugs share better than UUIDs.
// Crawlers get server-rendered OG tags via Vercel's UA rewrite to the backend
// /api/og/postcard endpoint (see frontend/vercel.json).
export const POSTCARD_SHARE_BASE = 'https://www.wernerdutoit.co.za';
export const postcardShareUrl = (slug) => `${POSTCARD_SHARE_BASE}/gallery/postcard/${slug}`;

// One-paste share blurb: the first 30 words of the story (then …), a blank
// line, then the canonical link. Paste straight into WhatsApp/etc — the teaser
// gives context and the link renders its own preview card. Falls back to the
// body, then to just the link when there's no text.
export const postcardShareText = (postcard) => {
  if (!postcard) return '';
  const url = postcardShareUrl(postcard.public_slug || postcard.id);
  const text = (postcard.story || postcard.body || '').trim();
  if (!text) return url;
  const words = text.split(/\s+/).filter(Boolean);
  const teaser = words.slice(0, 30).join(' ') + (words.length > 30 ? ' …' : '');
  return `${teaser}\n\n${url}`;
};
